import { render, staticRenderFns } from "./TopNavigationSitecore.vue?vue&type=template&id=3793377e"
import script from "./TopNavigationSitecore.vue?vue&type=script&lang=js"
export * from "./TopNavigationSitecore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports